import { Component, AfterViewInit, Input, ContentChildren, ViewChildren, QueryList, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../../encapsulation';
import { UBXTrackComponent } from '../../grid/track/track.component';
import { UBXButtonComponent } from '../button.component';

@Component({
    selector: 'ubx-button-group',
    templateUrl: './button-group.component.html',
    host: { class: 'ubx-button-group flx f-fd:c' },
    encapsulation
})
export class UBXButtonGroupComponent implements AfterViewInit {
    @Input() columns: string;

    @Input() gap = 10;
    @Input() xGap: string;
    @Input() yGap: string;

    @Input() jc: string;
    @Input() ji: string;
    @Input() ac: string;
    @Input() ai: string;

    @ContentChildren(UBXButtonComponent) buttons: QueryList<UBXButtonComponent>;
    @ViewChildren('tracks') tracks: QueryList<UBXTrackComponent>;

    constructor(
        private renderer: Renderer2,
        public el: ElementRef,
    ) { }

    ngAfterViewInit() {
        this.appendChildParent(this.tracks, this.buttons);
    }

    private appendChildParent(parent: QueryList<UBXTrackComponent>, child: QueryList<UBXButtonComponent>) {
        parent.forEach((p, i) => {
            child.forEach((c, j) => {
                if (i === j) {
                    this.renderer.appendChild(p.el.nativeElement, c.el.nativeElement);
                }
            });
        });
    }

    setColumns(columns: string): string {
        return columns !== undefined ? columns.replace(/[^1a-z@ -]/g, '$&a') : `${this.buttons.length}a`;
    }
}
